import connect from "@classdojo/web/utils/hoc/connect";
import { compose } from "recompose";
import IdeasRemote, { IdeasRemoteProps } from "./IdeasRemote";
import { BoardSlice } from "pods/board";
import { unselectBoard, selectBoardBySlug, IdeasSlice } from "src/pods/ideas";

type IdeasRemoteContainerProps = {
  params: { ideaId?: string };
};

const mapDispatchToProps = { unselectBoard };

const mapStateToProps = (state: IdeasSlice & BoardSlice, props: IdeasRemoteContainerProps) => {
  return {
    selectedBoard: selectBoardBySlug(state, props.params.ideaId!),
  };
};

export default compose<IdeasRemoteProps, IdeasRemoteContainerProps>(connect(mapStateToProps, mapDispatchToProps))(
  IdeasRemote,
);
